import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import Header from '../Dashboard/SubComponents/Header';
import Footer from '../Dashboard/SubComponents/Footer';

import { useUpdateCommonEmitter } from '../../../redux/hooks/useCommonEmitter';
import { useTheme } from '../../../redux/hooks/useTheme';
import { promptsData } from '../Dashboard/SubComponents/Prompt';
import {Prompt} from '../../utils/Interfaces/PromptGallery'
import { ScreenSizePopUp } from '../../utils/HelperComponents/ScreenSizePopUp';
 
const categorySvgs: Record<string, string> = {
  'All templates': 'https://dlvkyia8i4zmz.cloudfront.net/jFnYfnjmTvW6caevGI4p_category.svg',
  'General': 'https://dlvkyia8i4zmz.cloudfront.net/HZ3cP3mSACRJM2vGBbFw_Vector__32_.svg',
  'Calculator': 'https://dlvkyia8i4zmz.cloudfront.net/c11OAfYTXaAVdSiyagd7_computing.svg',
  'API': 'https://dlvkyia8i4zmz.cloudfront.net/XmBiHmN2QYW2alT3tDrh_scroll.svg',
  'AI': 'https://dlvkyia8i4zmz.cloudfront.net/bjrho71SlGgixv8D5iLJ_magicpen.svg',
  'Game':'https://dlvkyia8i4zmz.cloudfront.net/QR38jtw0RPe5ATRUAF8m_Frame_1618872947.svg'
};


export default function PromptGallery() {
  const { theme } = useTheme();
  const [selectedCategory, setSelectedCategory] = useState('All templates')
  const [expandedPromptId, setExpandedPromptId] = useState<string | null>(null);
  const [isScreenTooSmall, setIsScreenTooSmall] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      setIsScreenTooSmall(window.innerWidth <= 861);
    };
  
   
    handleResize();
  
    
    window.addEventListener('resize', handleResize);
  
    
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);    
    const hash = window.location.hash.slice(1); 
    if (hash && Object.keys(categorySvgs).includes(hash)) {
      setSelectedCategory(hash);
      window.history.pushState(
        '', 
        document.title, 
        window.location.pathname + window.location.search
      );
    }
  }, []);
  
  const navigate = useNavigate();
  const handleTryPrompt = (prompt: Prompt) => {
    console.log(`Trying prompt: ${prompt.description}`)
    localStorage.setItem('savedPrompt', prompt.description);
    navigate("/")
    setTimeout(() => {
      const element = document.getElementById('promptsection');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 0);
  }
  const toggleDescription = (id: string) => {
    setExpandedPromptId(expandedPromptId === id ? null : id);
  };
  const filteredPrompts = promptsData.filter(prompt => 
    selectedCategory === 'All templates' ? true : prompt.type.toLowerCase() === selectedCategory.toLowerCase()
  );

  if (isScreenTooSmall) {
    return <ScreenSizePopUp />;
  }


  return (
   <> 
     <Header className='' noPadding={true} addBottomBorder={true} isDifferentStyle={true} paddingTop={true} hideBorder paddingX={true} paddingY={true}  />
    <div className="flex prompt-gallery pb-[20px]" style={{  alignItems:'flex-start' }}>
      {/* Sidebar */}
      <div style={{position:'sticky', top:'150px'}} className="w-[19rem] pr-[10px] custom-scrollbar  flex-shrink-0 overflow-y-auto prompt-gallery pl-[50px]">
          <div className='rounded-[20px] space-y-1 custom-scrollbar  prompt-gallery-b border' style={{
            backgroundColor: 'transparent',
            // borderColor: theme.analyzeCardBorder,
            height: 'calc(100vh - 130px)',
            overflowY: 'auto'
          }}>
            <ul className='prompt-option'>
              {['All templates', 'General', 'Calculator', 'API', 'AI','Game'].map((category) => (
                <li key={category} className={`mb-2 prompt-on ${selectedCategory === category ? 'active' : ''}`}>
                  
                  <button
                    data-category={category}
                    style={{
                        color: theme.chatRightBarIcon,
                        background: selectedCategory === category ? theme.promptGalleryIconBg : 'transparent',
                        borderLeft: selectedCategory === category ? '1px solid #fd4b92' : '1px solid transparent',
                        // backgroundColor: selectedCategory === category ? theme.promptActive: theme.promptUnactive
                      }}
                    className="w-full text-left flex justify-start items-center text-[16px] py-[14px] px-4 box-border"
                    onClick={() => setSelectedCategory(category)}
                  >
                    {/* <img
                      src={categorySvgs[category]}
                      alt={`${category} icon`}
                      className="w-7 h-5 galleryIcon mr-2"
                      style={{color:theme.chatRightBarIcon, filter: selectedCategory === category ? 'invert(59%) sepia(29%) saturate(1593%) hue-rotate(310deg) brightness(92%) contrast(88%)' : 'none' }}
                    /> */}
                    <img
                      src={categorySvgs[category]}
                      alt={`${category} icon`}
                      className="w-7 h-5 galleryIcon mr-2"
                      style={{
                        filter:
                          selectedCategory === category
                            ? ``
                            : "", // Change this for different themes
                      }}
                    />

                    <span className='leading-{10} text-{16px} font-{500}'>{category}</span>
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>

      {/* Main content */}
          <div className="flex-1 pl-8 pr-8 prompt-gallery mt-[14px]">
                  <h2 style={{color:theme.bannerHeading}} className="leading-{33px] text-[28px] font-[700] font-sora mb-2">
                        {selectedCategory === 'All templates' ? 'Prompt Gallery' : `${selectedCategory} Templates`}
                  </h2>      
                  <p style={{color:theme.leadFormSubHEading}} className="leading-{27px] text-[18px] font-[400] mb-6">
                    {selectedCategory === 'All templates' 
                      ? 'Get inspiration from a collection of prompts'
                      : `Browse our ${selectedCategory.toLowerCase()} templates`}
                  </p>
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 pb-[70px]" >
                    {filteredPrompts.map((prompt) => (
                      <div  key={prompt.id} className="border prompt-gallery-b prompGallery-card p-[20px] rounded-[20px] overflow-hidden hover:text-[#fc5f66] hover:bg-[rgba(251,95,101,0.2)] box-border border transition-all duration-300 ease-in-out " style={{backgroundColor:theme.analyzecardbg, }}>
                      <div style={{borderRadius:'7px', overflow:'hidden'}}>
                      <img src={prompt.image} alt={prompt.title} className="w-full h-48 object-cover " loading='lazy' />
                      </div>
                       
                          <h2 style={{color: theme.bannerHeading}} className="leading-{21px] mt-[10px] text-[18px] font-[500]">{prompt.title}</h2>
                          <p className="leading-{21px] text-[14px] font-[400] mb-4" style={{ color: theme.leadFormSubHEading, textAlign:'start' }}>
                            {expandedPromptId === prompt.id
                              ? prompt.description
                              : prompt.description.length > 150
                              ? `${prompt.description.substring(0, 150)}...`
                              : prompt.description}
                              {prompt.description.length > 150 && (
                            <span
                              
                              className=" hover:underline mb-4 gradient-text"
                              onClick={() => toggleDescription(prompt.id)}
                            >
                              {expandedPromptId === prompt.id ? ' view less' : ' view more'}
                            </span>
                          )}
                          </p>
                          
                          <button
                            className="py-[12px] flex gap-[10px] try-prmp-btn active-gradient-start-now  px-[24px] rounded-[12px] text-white active:scale-95"
                            // style={{ background: theme.primary }}
                            style={{ 
                            }}
                            onClick={() => handleTryPrompt(prompt)} 
                          >
                          <span className='gradient-text text-[14px] font-[500]'>Try this prompt</span>
                          <span>
                          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M7.24072 5.60791L14.3943 5.60791L14.3943 12.7615" stroke="url(#paint0_linear_1921_2635)" stroke-width="1.25" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M4.37744 15.6235L14.2946 5.70636" stroke="url(#paint1_linear_1921_2635)" stroke-width="1.25" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                          <defs>
                          <linearGradient id="paint0_linear_1921_2635" x1="3.49988" y1="4.50024" x2="15.9999" y2="17.0002" gradientUnits="userSpaceOnUse">
                          <stop stop-color="#FF3AB6"/>
                          <stop offset="1" stop-color="#FB5F65"/>
                          </linearGradient>
                          <linearGradient id="paint1_linear_1921_2635" x1="3.49988" y1="5.00024" x2="15.4999" y2="17.0002" gradientUnits="userSpaceOnUse">
                          <stop stop-color="#FF3AB6"/>
                          <stop offset="1" stop-color="#FB5F65"/>
                          </linearGradient>
                          </defs>
                          </svg>
                          </span>
                          </button>
                       
                      </div>
                    ))}
                 </div>
          </div>
    </div>
   <div className='prompt-gallery'>
    <Footer />
   </div>  
    </>
  )
}